export enum LanCode {
  English = "en",
  Korean = "kr",
  Chinese = "cn",
  Japanese = "jp",
  German = "de",
  French = "fr",
  Spanish = "es",
}

export interface Language {
  code: LanCode;
  name: string;
}

export const languages: Language[] = [
  {
    code: LanCode.English,
    name: "English",
  },
  {
    code: LanCode.German,
    name: "Deutsch",
  },
  {
    code: LanCode.French,
    name: "Français",
  },
  {
    code: LanCode.Spanish,
    name: "Español",
  },
  {
    code: LanCode.Chinese,
    name: "简体中文",
  },
  {
    code: LanCode.Japanese,
    name: "日本語",
  },
  {
    code: LanCode.Korean,
    name: "한국어",
  },
];
